import { DEFAULT_PAGINATION } from 'core/constants/pagination.constants';
import { IYapeQrListParams } from 'core/model/interfaces/yape/yape.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { removeEmptyValues } from 'shared/utils/object.utils';
import { SLICE_NAMESPACE } from '../constants';
import type { IYapeState } from '../types';

export const fetchYapeQrList = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/fetchYapeQrList`,
  async (params: IYapeQrListParams, { getState }) => {
    const { yape } = getState();
    return apiService.yape.getYapeQrList(
      removeEmptyValues({
        ...params,
        page: yape.qr.list.pagination.currentPage,
      }),
    );
  },
);

export const fetchYapeQrListReducer: TSliceExtraReducer<IYapeState> = builder =>
  builder
    .addCase(fetchYapeQrList.pending, state => {
      state.qr.list.isLoading = true;
    })
    .addCase(fetchYapeQrList.rejected, state => {
      state.qr.list.isLoading = false;
      state.qr.list.pagination = DEFAULT_PAGINATION;
      state.qr.list.data = [];
    })
    .addCase(fetchYapeQrList.fulfilled, (state, { payload }) => {
      state.qr.list.data = payload.codes;
      state.qr.list.pagination = payload.pagination;
      state.qr.list.isLoading = false;
    });
